"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogActionType = void 0;
var DialogActionType;
(function (DialogActionType) {
    DialogActionType["Chat"] = "chat";
    DialogActionType["CheckItem"] = "checkItem";
    DialogActionType["CheckNoItem"] = "checkNoItem";
    DialogActionType["TakeItem"] = "takeItem";
    DialogActionType["GiveItem"] = "giveItem";
    DialogActionType["MergeAndGiveItem"] = "mergeAndGiveItem";
    DialogActionType["ModifyItem"] = "modifyItem";
    DialogActionType["CheckItemCanUpgrade"] = "checkItemCanUpgrade";
    DialogActionType["AddUpgradeItem"] = "addItemUpgrade";
    DialogActionType["GiveEffect"] = "giveEffect";
    DialogActionType["GiveSelfEffect"] = "giveSelfEffect";
    DialogActionType["CheckEffect"] = "checkEffect";
    DialogActionType["GiveCurrency"] = "giveCurrency";
    DialogActionType["CheckQuest"] = "checkQuest";
    DialogActionType["UpdateQuest"] = "updateQuest";
    DialogActionType["CheckHoliday"] = "checkHoliday";
    DialogActionType["CheckDailyQuest"] = "checkDailyQuest";
    DialogActionType["GiveQuest"] = "giveQuest";
    DialogActionType["HasQuest"] = "hasQuest";
    DialogActionType["GiveDailyQuest"] = "giveDailyQuest";
    DialogActionType["CheckLevel"] = "checkLevel";
    DialogActionType["CheckNPCsAndDropItems"] = "checkNearbyNPCsAndDropItems";
    DialogActionType["CheckAnyHostilesNearby"] = "checkAnyHostilesNearby";
    DialogActionType["DropItems"] = "dropItems";
    DialogActionType["KillSelfSilently"] = "killSelfSilently";
    DialogActionType["GrantAchievement"] = "grantAchievement";
})(DialogActionType || (exports.DialogActionType = DialogActionType = {}));
